<template>
    <div>
        <!-- Footer Start Here -->
        <footer
            class="footer-main bg_primary_blue_dark pt_100 pb_36"
            data-aos-offset="500"
            data-aos-delay="500"
        >
            <div class="container">
                <div class="row">
                    <div class="col-md-4 col-lg-3 col-xl-2">
                        <img
                            src="/maincss/images/footer_logo.svg"
                            alt="Footer Logo"
                            class="img-fluid"
                        />
                        <div class="address mt_58">
                            <h6 class="text_white heading6">Address:</h6>
                            <p
                                class="font_size_15 mt_12 text_primary_light_white opacity_70"
                            >
                                imprint city, 199N. Linder <br />
                                Rd Meridian, ID 83642
                            </p>
                        </div>
                        <div class="phone mt_30">
                            <h6 class="text_white heading6">Phone:</h6>
                            <div class="phone_li">
                                <a
                                    href="tel:866-303-7827"
                                    class="font_size_18 mt_4 text_primary_light_white opacity_70 text-white"
                                    >866-303-7827</a
                                >
                            </div>
                        </div>
                        <div class="email mt_30">
                            <h6 class="text_white heading6">Email:</h6>
                            <div class="phone_li">
                                <a
                                    href="mailto:info@imprintcity.com"
                                    class="font_size_16 mt_4 text_primary_light_white opacity_70 text-white"
                                    >info@imprintcity.com</a
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-md-8 col-lg-5 col-xl-7 pl_80 d-flex mt-4 pt-2 mt-md-0 pt-lg-0"
                    >
                        <div class="links footer-no-border">
                            <h4
                                class="font_size_24 text_white bottom_border mt_8"
                            >
                                Useful Link
                            </h4>
                            <ul class="footer_links mt_62">
                                <li>
                                    <router-link
                                        class="opacity_60"
                                        :to="{ name: 'DesignTemplates' }"
                                        >Design Templates</router-link
                                    >
                                </li>
                                <li>
                                    <router-link
                                        class="opacity_60"
                                        :to="{ name: 'ScreenPrinting' }"
                                        >Screen Printing</router-link
                                    >
                                </li>
                                <li>
                                    <router-link
                                        class="opacity_60"
                                        :to="{ name: 'Embroidery' }"
                                        >Embroidery</router-link
                                    >
                                </li>
                                <li>
                                    <router-link
                                        class="opacity_60"
                                        :to="{
                                            path: `/product-list/tshirt24`
                                        }"
                                        >24hours T-Shirts</router-link
                                    >
                                </li>

                                <li>
                                    <router-link
                                        class="opacity_60"
                                        :to="{ name: 'AboutUs' }"
                                        >About Us</router-link
                                    >
                                </li>
                            </ul>
                        </div>
                        <div class="links pl_100 ml_74">
                            <h4 class="font_size_24 text_white mt_8">&nbsp;</h4>
                            <ul class="footer_links mt_62">
                                <li>
                                    <router-link
                                        class="opacity_60"
                                        :to="{ name: 'Brands' }"
                                    >
                                        Brands
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="opacity_60"
                                        :to="{ name: 'colors_view' }"
                                    >
                                        Standard Decoration Colors
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        class="opacity_60"
                                        :to="{ name: 'DecorationMethods' }"
                                    >
                                        Decoration Services Overview
                                    </router-link>
                                </li>
                                <li
                                    v-if="
                                        $store.state.auth.user.user_type ==
                                        'Business'
                                    "
                                >
                                    <a
                                        href="#"
                                        class="opacity_60"
                                        @click="downloadPDF()"
                                    >
                                        Download Credit Application
                                    </a>
                                </li>
                                <li>
                                    <router-link
                                        class="opacity_60"
                                        :to="{ name: 'TermsConditions' }"
                                        >Terms & Conditions</router-link
                                    >
                                </li>
                                <li>
                                    <router-link
                                        class="opacity_60"
                                        :to="{ name: 'SiteMap' }"
                                        >Site Map</router-link
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-4 pl_54 col-xl-3 mt-4 mt-lg-0">
                        <div
                            class="d-md-flex d-lg-block d-block flex-wrap mt_38"
                        >
                            <div class="card_list d-flex pl_4 pr-0 flex-wrap">
                                <p class="mr_12 mb-0">
                                    <img
                                        src="/maincss/images/american-express-icon.svg"
                                        alt=" "
                                    />
                                </p>
                                <p class="mr_12 mb-0">
                                    <img
                                        src="/maincss/images/discover-icon.svg"
                                        alt=" "
                                    />
                                </p>
                                <p class="mr_12 mb-0">
                                    <img
                                        src="/maincss/images/mastercard-icon.svg"
                                        alt=" "
                                    />
                                </p>
                                <p class="mr_12 mb-0">
                                    <img
                                        src="/maincss/images/paypal-icon.svg"
                                        alt=" "
                                    />
                                </p>
                                <p class="mr_12 mb-0">
                                    <img
                                        src="/maincss/images/visa-icon.svg"
                                        alt=" "
                                    />
                                </p>
                            </div>

                            <ul
                                class="social_media_link mt_30 pl_4 pr-0 ml-md-auto ml-0 ml-lg-0"
                            >
                                <li
                                    v-if="linkValues.facebook"
                                    class="d-inline-block"
                                >
                                    <a
                                        target="_blank"
                                        :href="linkValues.facebook"
                                        ><img
                                            src="/maincss/images/facebook.svg"
                                            alt=" "
                                    /></a>
                                </li>
                                <li
                                    v-if="linkValues.instagram"
                                    class="d-inline-block"
                                >
                                    <a
                                        target="_blank"
                                        :href="linkValues.instagram"
                                        ><img
                                            src="/maincss/images/insta.svg"
                                            alt=" "
                                    /></a>
                                </li>
                                <li
                                    v-if="linkValues.twitter"
                                    class="d-inline-block"
                                >
                                    <a
                                        target="_blank"
                                        :href="linkValues.twitter"
                                        ><img
                                            width="17px"
                                            height="14px"
                                            src="/maincss/images/twitterxwhite.svg"
                                            alt=" "
                                    /></a>
                                </li>
                                <li
                                    v-if="linkValues.youtube"
                                    class="d-inline-block"
                                >
                                    <a
                                        target="_blank"
                                        :href="linkValues.youtube"
                                        ><img
                                            src="/maincss/images/youtube.svg"
                                            alt=" "
                                    /></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 mt_52 copyreight text-center">
                    <p class="font_size_14 mb-0 pt_18 text_white opacity_60">
                        ©2006-{{ currentYear }} imprintcity.com. All rights reserved.
                    </p>
                </div>
                <!--user active popup-->
                <div
                    class="modal useractiveform-popup fade h-auto register-modal-popup"
                    id="useractive"
                    tabindex="-1"
                    aria-labelledby="useractive"
                    aria-hidden="true"
                    data-keyboard="false"
                    data-backdrop="static"
                >
                    <div
                        class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                    >
                        <div class="modal-content">
                            <div class="modal-body">
                                <a
                                    href="#"
                                    class="popup-close"
                                    id="popup-close"
                                    data-dismiss="modal"
                                >
                                    <img
                                        src="/maincss/images/cancel.svg"
                                        alt=" "
                                    />
                                </a>
                                <div class="login-form">
                                    <h3>Attention!</h3>
                                    <p>
                                        Please check your registered email to
                                        verify your account.
                                    </p>
                                </div>

                                <div class="d-md-flex">
                                    <a
                                        href="#"
                                        class="btn btn_orange bg_primary_orange text_white w-100 mt_34 mb_32 btn_h60"
                                        data-path="/MyAccount"
                                        data-toggle="modal"
                                        data-target="#login"
                                        data-dismiss="modal"
                                        >Login</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <!-- Footer End Here -->
        <button class="gototop d-none">
            <i class="fa fa-angle-up" aria-hidden="true"></i>
        </button>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
import { mapGetters } from "vuex";
import { FETCH_ADMIN_OPTIONS } from "@/store/actions.type";
export default {
    name: "RwvFooter",
    data() {
        return {
            post_data: { email: "" },
            linkValues: {
                facebook: "",
                instagram: "",
                twitter: "",
                youtube: ""
            },
            api_url: ApiService.siteUrl()
        };
    },
    computed: {
        ...mapGetters([
            "currentUserClient",
            "isAuthenticatedClient",
            "adminOptions"
        ]),
        currentYear() {
            return new Date().getFullYear();
        }
    },
    mounted() {
        this.$store.dispatch(FETCH_ADMIN_OPTIONS);
    },
    watch: {
        adminOptions() {
            this.social_links = this.adminOptions;
            this.adminOptions.forEach((link) => {
                this.linkValues[link.option_key] = link.option_value;
            });
        }
    },
    methods: {
        downloadPDF() {
            var url = this.api_url + "uploads/Business_Credit_Application.pdf";

            var a = document.createElement("a");
            a.href = url;
            let fileName = url.split("/").pop();
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
            console.log(a);
        },

        onSubmit() {
            var _this = this;
            _this.$validator.validateAll("subscribers-form").then((isValid) => {
                if (isValid) {
                    new Promise(() => {
                        ApiService.post("/subscribers", _this.post_data)
                            .then(({ data }) => {
                                // console.log(data);
                                _this.post_data.email = null;
                                if (data.success) {
                                    _this.$toast.success(
                                        "Email submitted Successfully.",
                                        {
                                            position: "top-right"
                                        }
                                    );
                                    setTimeout(() => {
                                        _this.errors.clear();
                                    }, 1000);
                                }
                                console.log(data, _this.errors.items);
                            })
                            .catch(({ response }) => {
                                console.log("exception", response.data.error);
                            });
                    });
                } else {
                    console.log("form's error", _this.errors);
                }
            });
        }
    }
};
</script>
